import * as React from "react"

const SvgVerticalSpacing = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20 21H4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 20q0-.424.288-.712A.97.97 0 0 1 4 19h16q.424 0 .712.288.288.287.288.712c0 .425-.096.52-.288.712A.97.97 0 0 1 20 21m0-16H4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 4q0-.424.288-.712A.97.97 0 0 1 4 3h16q.424 0 .712.288Q21 3.575 21 4c0 .425-.096.52-.288.713A.97.97 0 0 1 20 5m-7 7q0 .424-.287.713A.97.97 0 0 1 12 13a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 12q0-.424.287-.713A.97.97 0 0 1 12 11q.424 0 .713.287.287.288.287.713m0 4a.97.97 0 0 1-.287.712A.97.97 0 0 1 12 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 16q0-.424.287-.713A.97.97 0 0 1 12 15q.424 0 .713.287.287.288.287.713m0-8q0 .424-.287.713A.97.97 0 0 1 12 9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 8a.97.97 0 0 1 .287-.712A.97.97 0 0 1 12 7a.97.97 0 0 1 .713.288A.97.97 0 0 1 13 8" />
  </svg>
)
export default SvgVerticalSpacing
